import React, { useEffect, useRef } from 'react';
import { Button, Empty, Tag } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { sendRecommendationEvents } from '@/apis/posts';
import usePrivateAction from '@/utils/usePrivateAction';
import './index.scss';

const RecommendationItem = ({ item, createdAt }) => {
  const ref = useRef(null); const navigate = useNavigate(); const { busy, run } = usePrivateAction();
  const userId = useSelector(state => state.user.userInfo?.id);
  const inWindow = Date.parse(createdAt) + 7 * 86400000 > Date.now();
  useEffect(() => {
    if (!item.post || !inWindow || item.impression_at || !window.IntersectionObserver) return;
    let pending = false; let alive = true;
    const observer = new IntersectionObserver(entries => {
      if (document.hidden || pending || !entries.some(entry => entry.isIntersecting)) return;
      pending = true;
      sendRecommendationEvents([{ item_id: item.id, action: 'impression' }]).then(() => { if (alive) observer.disconnect(); }).catch(() => { pending = false; });
    }, { threshold: 0.5 });
    observer.observe(ref.current);
    return () => { alive = false; observer.disconnect(); };
  }, [item.id, item.post, item.impression_at, inWindow]);
  const open = () => {
    if (!inWindow) { navigate(`/posts/${item.post.id}`); return; }
    run(() => sendRecommendationEvents([{ item_id: item.id, action: 'impression' }, { item_id: item.id, action: 'click' }]), () => {
      navigate(`/posts/${item.post.id}`, { state: { recommendation: { itemId: item.id, postId: item.post.id, userId, createdAt } } });
    }, '推荐来源记录失败，请重试或直接查看帖子');
  };
  return <section ref={ref} className="recommendation-item">
    <div className="recommendation-item-heading"><span className="recommendation-item-rank">推荐 {item.rank}</span>{!item.available && <Tag>当前不再参与推荐</Tag>}</div>
    {item.post ? <><h3>{item.post.title}</h3><p className="recommendation-item-description">{item.post.description}</p>{item.recommendation_reasons?.length > 0 && <p className="recommendation-item-reasons">{item.recommendation_reasons.join(' · ')}</p>}
      <div className="recommendation-item-actions"><Button type="primary" loading={busy} onClick={open}>查看帖子</Button>
      <Button type="text" onClick={() => navigate(`/posts/${item.post.id}`)}>直接查看</Button></div>
      <p className="recommendation-item-hint">{inWindow
        ? '“查看帖子”会记录推荐来源，便于关联后续报名；“直接查看”仅打开帖子。'
        : '这次推荐已超过 7 天，两种方式均直接打开帖子，不再关联推荐来源。'}</p>
    </> : <p>这条推荐的帖子当前不可用</p>}
  </section>;
};
const RecommendationBatch = ({ batch }) => <div className="recommendation-batch">{batch.items.length
  ? batch.items.map(item => <RecommendationItem key={item.id} item={item} createdAt={batch.created_at} />)
  : <Empty description="本次没有匹配到推荐帖子" />}</div>;
export default RecommendationBatch;
